// VFX: Glassmorphism Lower Third
// Category: lower-thirds · Tags: lower-third, glass, frosted, premium, apple
// Card frosted glass com nome e titulo. Blur por tras, borda sutil.
import { AbsoluteFill, useCurrentFrame, useVideoConfig, spring, interpolate } from "remotion";
import React from "react";

export default function LowerGlassCardFrosted600Ms() {
  const frame = useCurrentFrame();
  const { fps } = useVideoConfig();
  const sp = spring({ frame, fps, config: { stiffness: 120, damping: 20 } });

  return (
    <AbsoluteFill style={{
      background: "linear-gradient(135deg, #1e293b 0%, #0a0e1a 60%, #1e1b4b 100%)",
      justifyContent: "flex-end", alignItems: "flex-start", padding: "0 0 200px 80px",
    }}>
      {/* decorative orbs to show the frosted blur effect */}
      <div style={{ position: "absolute", top: "30%", left: "20%", width: 320, height: 320, borderRadius: "50%",
        background: "#a855f7", filter: "blur(80px)", opacity: 0.5 }} />
      <div style={{ position: "absolute", bottom: "20%", right: "10%", width: 280, height: 280, borderRadius: "50%",
        background: "#06b6d4", filter: "blur(80px)", opacity: 0.4 }} />

      <div style={{
        background: "rgba(255,255,255,0.08)", backdropFilter: "blur(24px)",
        WebkitBackdropFilter: "blur(24px)",
        border: "1px solid rgba(255,255,255,0.18)", borderRadius: 18,
        padding: "20px 32px", minWidth: 380,
        transform: `translateY(${interpolate(sp, [0, 1], [28, 0])}px) scale(${interpolate(sp, [0, 1], [0.94, 1])})`,
        opacity: sp,
        boxShadow: "0 12px 40px rgba(0,0,0,0.32), inset 0 1px 0 rgba(255,255,255,0.12)",
      }}>
        <p style={{ margin: 0, fontSize: 30, fontWeight: 700, color: "#f8fafc", fontFamily: "sans-serif" }}>Maria Costa</p>
        <p style={{ margin: "4px 0 0", fontSize: 18, color: "rgba(248,250,252,0.65)", fontWeight: 400, fontFamily: "sans-serif" }}>
          Head of Design · Dimus
        </p>
      </div>
    </AbsoluteFill>
  );
}

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
